/* eslint-disable no-unused-expressions */

import React, { Component } from "react";
import sysJwt from "../../../utils/sysJwt";
import SysForm from "../../commonComponents/sysForm";
import { post } from "../../../utils/sysAxios";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { confirmAlert } from "react-confirm-alert";
import { apiDataToDropdownList } from "../../../utils/sysHelpers";
import GridTable from "@nadavshaar/react-grid-table";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { toastError } from "../../../utils/sysToast";

class PipefittersRequests extends Component {
  state = {
    data: {
      agentId: "",
      amount: "",
      diamonds: "",
      billDate: "",
      billNumber: "",
    },

    contentHeader: "طلبات السباكين",
    addButtonLabel: "اضافة فاتورة",
    addButtonIcon: "fa fa-plus",

    dataUrl: "/api/data/GetPipefittersRequest",

    inEditMode: false,
    inModalMode: false,
    modalHeaderAdd: "اضافة فاتورة وكيل",
    modalSubmitButtonLabelAdd: "اضافة",
    modalSubmitButtonIconAdd: "fa fa-plus",
    modalHeaderEdit: "تعديل فاتورة وكيل",
    modalSubmitButtonLabelEdit: "تعديل",
    modalSubmitButtonIconEdit: "fa fa-edit",
    modalWidth: "50vw",

    editEntityId: 0,

    allAgents: [],
    allPipefitters: [],
    dates: [new Date(new Date().setDate(new Date().getDate() - 7)), new Date()],
    agentId: null,
    pipefitterId: null,

    tableData: [],
    tableColumns: [
      {
        id: 1,
        label: "ID",
        field: "ID",
        width: "100px",
      },
      {
        id: 2,
        label: "السباك",
        field: "PIPEFITTER_NAME",
      },
      {
        id: 3,
        label: "الوكيل",
        field: "AGENT_NAME",
      },
      {
        id: 4,
        label: "الجائزة",
        field: "GIFT_NAME",
      },
      {
        id: 5,
        label: "ماسات الجائزة",
        field: "REQUIRED_DIAMONDS",
      },
      {
        id: 6,
        label: "تم التسليم",
        field: "IS_RECEIVED",
        width: "120px",
        cellRenderer: ({ data }) => {
          return (
            <span>
              <b>&nbsp;{data.IS_RECEIVED ? "نعم" : "لا"}&nbsp;</b>
            </span>
          );
        },
      },
      {
        id: 7,
        label: "تاريخ التسليم",
        field: "RECEIVE_DATE",
      },
      {
        id: 8,
        label: "تاريخ الادخال",
        field: "INSERT_DATE",
      },
    ],
  };

  componentDidMount() {
    this.getAllAgentsDropdown();
    this.getAllPipefittersDropdown();
    this.getData();
  }

  updateForm = (inputId, inputValue) => {
    var data = this.state.data;
    data[inputId] = inputValue;
    this.setState({ data });
  };

  showForm() {
    this.setState({ inModalMode: true });
  }

  closeModal() {
    var data = this.state.data;

    Object.keys(data).forEach(function (key) {
      Array.isArray(data[key]) ? (data[key] = []) : (data[key] = null);
    });

    this.setState({
      inModalMode: false,
      inEditMode: false,
      data: data,
      editEntityId: 0,
    });

    this.getData();
  }

  getData() {
    if (!this.state.dates[0] || !this.state.dates[1]) {
      toastError("يرجى اختيار التاريخ");
    } else {
      post(
        this.state.dataUrl,
        {
          dateFrom: this.state.dates[0],
          dateTo: this.state.dates[1],
          agentId: this.state.agentId,
          pipefitterId: this.state.pipefitterId,
        },
        this.props.updateIsLoading
      ).then((apiResponse) => {
        this.setState({ tableData: apiResponse.data.respData.data });
      });
    }
  }

  getAllAgentsDropdown() {
    post("/api/data/GetAllAgents", null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({
          allAgents: apiResponse.data.respData.data,
        });
      }
    );
  }
  getAllPipefittersDropdown() {
    post("/api/data/GetAllPipefitters", null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({
          allPipefitters: apiResponse.data.respData.data,
        });
      }
    );
  }

  doSubmit() {
    const submitData = Object.assign({}, this.state.data);

    if (this.state.inEditMode) {
      submitData["id"] = this.state.editEntityId;
    }

    post(
      this.state.inEditMode ? this.state.editUrl : this.state.addUrl,
      submitData,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      if (apiResponse.data.respCode === 0) {
        this.props.updateIsLoading(false);
        this.closeModal();
      }
    });
  }

  render() {
    return (
      <div className="sys-content-component fade-in">
        <div className="row">
          <div className="col">
            <h4>{this.state.contentHeader}</h4>
          </div>
          <div className="col-10 flex-container-left">
            التاريخ:
            <Calendar
              selectionMode="range"
              showIcon="true"
              value={this.state.dates}
              className="flex-item-left mr-2"
              onChange={(e) => this.setState({ dates: e.value })}
              style={{ width: "250px" }}
            />
            &nbsp; الوكيل:
            <Dropdown
              value={this.state.agentId}
              showClear={true}
              options={this.state.allAgents}
              filter={true}
              onChange={(e) => this.setState({ agentId: e.target.value })}
            />
            &nbsp; السباك:
            <Dropdown
              value={this.state.pipefitterId}
              showClear={true}
              options={this.state.allPipefitters}
              filter={true}
              onChange={(e) => this.setState({ pipefitterId: e.target.value })}
            />
            &nbsp;
            <Button
              label="بحث"
              className="p-button-secondary"
              disabled={this.props.isLoading}
              onClick={() => {
                this.getData();
              }}
            />
            &nbsp;&nbsp;
          </div>
        </div>
        <hr />
        <GridTable
          columns={this.state.tableColumns}
          rows={this.state.tableData}
          pageSizes={[10, 15, 20, 30, 40]}
          showColumnVisibilityManager={false}
          texts={{
            search: "بحث:",
            totalRows: "إجمالي عدد البيانات:",
            rows: "الصف:",
            selected: "المحدد",
            rowsPerPage: "عدد الصفوف في الصفحة:",
            page: "الصفحة:",
            of: "من",
            prev: "السابق",
            next: "التالي",
            columnVisibility: "اظهار الاعمدة",
          }}
        />
      </div>
    );
  }
}

export default PipefittersRequests;
